import script from "./WksExtraInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksExtraInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./WksExtraInfoModal.vue?vue&type=style&index=0&id=fe38a7a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe38a7a0"]])

export default __exports__